import React from "react";
import { useInjection } from "inversify-react";
import { AppController } from "@dropDesk/presentation/app/app.controller";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import {
    Actions,
    CancelButton,
    Container,
    DiscardButton,
    Title,
} from "@dropDesk/presentation/pages/chat/ui/modals/modal_discard_image_editor/styled";
import { SharedColors } from "@dropDesk/domain/entities/theme/app_colors";

const ModalDiscardImageEditor = (
    {
        open,
        onCancel,
        onDiscard,
    }: {
        open: boolean;
        onCancel: () => void;
        onDiscard: () => void;
    }
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ModalMain
            open={open}
            onRequestClose={onCancel}
            width={360}
            keyboard={false}
            renderComponent={
                <Container background={colors.onBackground}>
                    <Title color={colors.text}>Deseja descartar a seleção?</Title>
                    <Actions>
                        <CancelButton color={colors.text} onClick={onCancel} type="button">
                            Cancelar
                        </CancelButton>
                        <DiscardButton
                            background={colors.accent}
                            color={SharedColors.white}
                            onClick={onDiscard}
                            type="button"
                        >
                            Descartar
                        </DiscardButton>
                    </Actions>
                </Container>
            }
        />
    );
};

export default ModalDiscardImageEditor;
